import { ClueSpec } from "./ClueSpec";
import { Mode } from "./components/CrosswordMode";
import { Clue } from "./models/clue";
import { Atted } from "./utils/misc";


export class GridCellState {
    // Each cell can be part of an across clue, a down clue, both, or neither
    containingAcrossClue: Clue  | null = null;
    containingDownClue: Clue  | null = null;
    // clueNum is set if we are at the start of a clue
    clueNum: ClueSpec = new ClueSpec();

    userText: string = "";
    solutionText: string = "";
    showText: boolean = false;
    enteringUserKey: string = "";

    public PersistenceText = (): string =>
        Atted(this.userText)+Atted(this.enteringUserKey);
    
    public setContainingClueNum(clue : Clue): void {
        if (clue.isAcross) {
            this.containingAcrossClue = clue;
        } else {
            this.containingDownClue = clue;
        }
    }

    public isBlack(): boolean {
        return !this.containingAcrossClue  && !this.containingDownClue;
    }

    public getText(mode: Mode) {
        if (mode === "user" || mode === "withErrors") {
            return this.userText;
        } else {
            return this.solutionText;
        }
    }

    public getClass(mode: Mode) {
        let cellClass = "cellnormal";
        if (mode === "withErrors" && this.solutionText && this.userText !== this.solutionText) {
            cellClass = "cellerror";
        }
        // add selected if it is....
        return cellClass;
    }
}
